export const baseState = {
  attribute: {
    attributesList: [],
    currentReadAttribute: {}
  },
  catalog: {
    catalogTree: [],
    catalogList: [],
    tenantCatalogList: [],
    partnerCatalogList: [],
    generatedTree: [],
    imageLibraryList: [],
    currentReadCatalog: {}
  },
  item: {
    currentSearchCatalogId: "",
    itemList: [],
    currentReadItem: {},
    currentItemLocationObject: {}
  },
  partner: {
    partnerList: [],
    stockpointList: [],
    editPartner: null,
    partnerPreferences: {},
    partnerListLite: []
  },
  role: {
    roleList: []
  },
  permission: {
    permissionList: [],
    permissionsByRole: [],
    userPermissionList: []
  },
  tenant: {
    tenantsList: [],
    adsCount: [],
    tenantSubAdminList: [],
    currentTenantAccess: "",
    tenantPreferences: {},
    tenantListLite: []
  },
  faq: {
    faqList: []
  },
  delivery: {
    deliveryList: []
  },
  servicerequest: {
    ServiceRequestList: [],
    SubcategoryList: []
  },
  auth: {
    _id: null,
    email: null,
    isActive: false,
    otpVerified: false,
    permissions: {},
    phone: "",
    securityQA: {},
    userName: "",
    catalogInfo: [],
    userRole: ""
  },
  order: {
    tenantOrders: [],
    sellerOrders: [],
    manufacturerOrders: [],
    checkoutHistory: []
  },
  notification: {
    allNotifications: [],
    isModalShow: false,
    orderNotification: {},
    currentOrderDetails: {}
  },
  advertisement: {
    adList: [],
    currentAdObject: {}
  },
  inventory: {
    inventoryList: []
  },
  passwordReset: {
    email: "",
    refId: "",
    userType: ""
  },
  taxcode: {
    taxcodeList: [],
    currentTaxcodeObject: {}
  },
  coupon: {
    couponCodeList: [],
    currentCouponObject: {}
  },
  customer: {
    customerList: []
  },
  profileUpdate: {
    meTenant: null
  },
  accessrule: {
    accessList: [],
    currentAccessobject: {}
  },
  subscriptionplan: {
    subscriptionplanList: [],
    currentSubscriptionObject: {}
  },
  invoice: {
    partnerInvoiceList: {},
    singleInvoiceData: {},
    partnerInvoiceBillDetails: {},
    myInvoiceHistoryPartner: {},
    partnerMyUnbilledInvoiceBills: {},
    partnerUnbilledInvoiceBillsByTenant: {}
  },
  subscription: {
    subscriptionGetData: {},
    subscribedPartnerList: {},
    subscriptionSellerMyList: {},
    transactionsList: []
  },
  walletstatement: {
    walletStatementData: {},
    partnerWalletStatementData: {}
  },
  serviceticket: {
    openServiceTicket: {},
    storeTicketData: {}
  },
  commission: {
    editCommissionRule: {},
    fetchCommissionRule: {}
  },
  payment: {}
};
